import React, { useState } from 'react';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === product.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? product.images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="product-card">
      <div className="image-slider">
        {/* <button className="prev-btn" onClick={prevImage}>‹</button> */}
        <img src={product.images[currentImageIndex]} alt={product.name} />
        {/* <button className="next-btn" onClick={nextImage}>›</button> */}
      </div>
      <h3>{product.name}</h3>
      {/* <p>{product.description}</p> */}
      {/* <ul className="features">
        {product.features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul> */}
    </div>
  );
};

export default ProductCard;
